import { ActivityServices } from './activities.services';
import { DeviationServices } from './deviation.services';
import { DeviationTopic } from '../../deviation/models/deviationTopic';
import { Department, UserRole } from './../models/deviation';
import { BaseServices } from './../../kuba.services';
import { Observable, of } from 'rxjs';
import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  ActivatedRoute
} from '@angular/router';
import { BusinessDepartmentService } from './../../business-department.services';
import { RiskanalysisService } from './risk-analysis.service';
import {
  Riskanalysis,
  ApprovalNotices,
  Business
} from './../models/riskanalysis';
import { ProjectServices } from 'src/app/kuba/projects/services/project.service';
import { Category } from 'src/app/kuba/businesses/models';

@Injectable()
export class RiskAnalysisListResolver {
  constructor(private backend: RiskanalysisService) {}
  resolve(route: ActivatedRouteSnapshot): Observable<Riskanalysis[]> {
    if (
      Number(BaseServices.roleId) !== UserRole.PORTAL &&
      Number(BaseServices.roleId) !== UserRole.ADMIN
    ) {
      return this.backend.list();
    }
    // Return empty observable array if access is restricted
    return of([]);
  }
}

@Injectable()
export class RiskAnalysisEditResolver {
  constructor(private backend: RiskanalysisService) {}
  resolve(route: ActivatedRouteSnapshot) {
    let riskId = +route.params['rid'];
    return this.backend.getById(riskId);
  }
}
@Injectable()
export class FollowupDepartmentForAdminResolver
{
  constructor(private backend: DeviationServices) {}
  resolve(route: ActivatedRouteSnapshot): Observable<Department[]> {
    if(Number(BaseServices.roleId) === UserRole.ADMIN) {
        let riskId = +route.params['rid'];
        return this.backend.getDepartmentsForAdmin(riskId);
    }
    return of([]);
  }
}
@Injectable()
export class RiskAnalysisDepartmentResolver {
  constructor(private backend: BusinessDepartmentService) {}
  resolve(route: ActivatedRouteSnapshot): Observable<Department[]> {
    return this.backend.getCachedBusinessDepartment();
  }
}
@Injectable()
export class RiskAnalysisTopicForAdminResolver
{
  constructor(private backend: DeviationServices) {}
  resolve(route: ActivatedRouteSnapshot): Observable<DeviationTopic[]> {
    if (+BaseServices.roleId === UserRole.ADMIN) {
      let riskId = +route.params['rid'];
      return this.backend.getTopicsForAdmin(riskId);
    }
    return of([]);
  }
}
@Injectable()
export class RiskAnalysisTopicCachedResolver
{
  constructor(private backend: RiskanalysisService) {}
  resolve(route: ActivatedRouteSnapshot): Observable<DeviationTopic[]> {
    if (+BaseServices.roleId === UserRole.PORTAL) {
      return this.backend.getTopicByPortal(BaseServices.PortalId);
    } else if (+BaseServices.roleId === UserRole.ADMIN) {
      return null;
    } else {
      return this.backend.getTopicByBusiness(BaseServices.BusinessId);
    }
  }
}
@Injectable()
export class ApprovalNoticesResolver {
  constructor(
    private backend: RiskanalysisService,
    private router: ActivatedRoute
  ) {}
  resolve(route: ActivatedRouteSnapshot) {
    if (BaseServices.roleId === '1' || BaseServices.roleId === '2') {
    } else {
      return this.backend.getApprovalNoticeByBusiness();
    }
  }
}
@Injectable()
export class BusinessesListResolver {
  constructor(
    private backend: RiskanalysisService,
    private router: ActivatedRoute
  ) {}
  resolve(route: ActivatedRouteSnapshot): Observable<Business[]> {
    return this.backend.getBusinesses();
  }
}
@Injectable()
export class RiskAnalysisLogResolver {
  constructor(private backend: RiskanalysisService) {}
  resolve(route: ActivatedRouteSnapshot) {
    let riskId = +route.params['rid'];
    return this.backend.getRiskAnalysisLog(riskId);
  }
}
@Injectable()
export class RiskAnalysisAdminResolver {
  constructor(private backend: RiskanalysisService) {}
  resolve(route: ActivatedRouteSnapshot) {
    return this.backend.getRiskAnalysisForAdmin(
      BaseServices.ApplicationId,
      BaseServices.BusinessId
    );
  }
}
@Injectable()
export class RiskAttachmentResolver {
  constructor(private backend: RiskanalysisService) {}
  resolve(route: ActivatedRouteSnapshot) {
    let riskId = +route.params['rid'];
    return this.backend.getRiskAttachmentByRisk(riskId);
  }
}
@Injectable()
export class UserForAdminResolver {
  constructor(private backend: RiskanalysisService) {}
  resolve(route: ActivatedRouteSnapshot) {
    if (Number(BaseServices.roleId) === UserRole.ADMIN) {
        return this.backend.getUserForAdminRisk(+route.params['rid']);
    }
    return of([]);
  }
}

@Injectable()
export class RiskAnalysisCategoryResolver {
  constructor(private backend: RiskanalysisService) {}
  resolve(route: ActivatedRouteSnapshot) {
    let businessId: number;
    businessId = BaseServices.BusinessId;
    if(Number(BaseServices.roleId) === UserRole.PORTAL){
      return this.backend.getCategoryListForPortal(BaseServices.PortalId);
    }
    else if (Number(BaseServices.roleId) !== UserRole.ADMIN) {
      return this.backend.getCategoryList(businessId, BaseServices.ApplicationId);
    }
    // Return empty observable array if access is restricted
    return of([]);
  }
}
